import { useEffect, useState } from "react";
import useApi from "./useApi";

interface ShopifyConfig {
  id: number;
  agencyName: string;
  clientId: string;
  clientSecret: string;
  emailAddress: string;
  accessToken: string;
  refreshToken: string;
  scope?: string;
  teamId: number;
  token?: string;
}

export default function useShopifyConfigs(teamId: number) {
  const [items, setItems] = useState<ShopifyConfig[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const api = useApi();

  useEffect(() => {
    async function fetchConfigs() {
      setLoading(true);
      const resp = await api.messaging.get(`Shopify/Integrations/`);
      setItems(await resp.json());
      setLoading(false);
    }

    fetchConfigs();
  }, [api.messaging]);

  return { items, loading };
}
